import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useOpcionais } from '../../../../contexts/OpcionaisContext'
import { valorOpcional } from '../../constantsCardOpcionais'

const WrapperValorTotalOpcional = styled.div`
  .valor-opcionais {
    font-size: 18px;
    margin-bottom: 20px;
  }
`

const ValorTotalOpcional = () => {
  const { opcionaisSelecionados, modalidadesEscolhidaOpcionais } = useOpcionais()
  const [ valorTotalOpcional, setValorTotalOpcional ] = useState()

  useEffect( () => {
    if ( opcionaisSelecionados.length ) {
      let valorSomado = opcionaisSelecionados.reduce( ( acc, opcional ) => {
        if ( opcional.preco ) {
          return acc + opcional.preco
        }

        return acc
      }, 0 )

      if ( opcionaisSelecionados.length === 1 && modalidadesEscolhidaOpcionais.length > 1 ) {
        valorSomado *= modalidadesEscolhidaOpcionais.length
      }

      setValorTotalOpcional( valorSomado )
    }
  }, [ opcionaisSelecionados, modalidadesEscolhidaOpcionais ] )

  if ( valorTotalOpcional ) {
    return (
      <WrapperValorTotalOpcional>
        <p
          className="valor-opcionais"
        >
          <strong>
            { valorOpcional( valorTotalOpcional ) }
          </strong>
        </p>
      </WrapperValorTotalOpcional>
    )
  }

  return null
}

export default ValorTotalOpcional
